import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Barra de ações sticky no rodapé de um formulário longo.
 * Children = botões (ex.: Salvar). Fica grudada no fundo do container scrollável.
 */
export default function FormActionBar({ children, sx }) {
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 2,
        mt: 2,
        py: 1.5,
        px: { xs: 2, md: 0 },
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        // recuo negativo p/ encostar nas bordas do card no mobile
        mx: { xs: -2, md: 0 },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

FormActionBar.propTypes = { children: PropTypes.node, sx: PropTypes.object };
